import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Gift, Star } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function LoyaltyJoinCard({ entityType, entityId }) {
  const { user } = useAuth();
  const [programs, setPrograms] = useState([]);
  const [joined, setJoined] = useState({});

  useEffect(() => {
    api.get(`/loyalty/programs?entity_type=${entityType}&entity_id=${entityId}`).then((r) => setPrograms(r.data)).catch(() => {});
    if (user) api.get("/my/rewards").then((r) => {
      const map = {};
      (r.data.programs || []).forEach((x) => { map[x.program.id] = true; });
      setJoined(map);
    }).catch(() => {});
  }, [entityType, entityId, user]);

  if (!programs.length) return null;

  const join = async (p) => {
    try {
      await api.post("/loyalty/join", { program_id: p.id, consent: true, source: "profile" });
      toast.success(`Welcome to ${p.name}!`);
      setJoined({ ...joined, [p.id]: true });
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="px-6 md:px-12 lg:px-20 py-8" data-testid="loyalty-join-section">
      {programs.map((p) => (
        <div key={p.id} className="bg-gradient-to-r from-rose-500/15 to-amber-500/10 border border-rose-500/30 rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-rose-500/20 flex items-center justify-center shrink-0"><Gift className="text-rose-400" size={22} /></div>
          <div className="flex-1">
            <p className="overline text-rose-400 text-xs">Gulf Coast VIP Rewards</p>
            <p className="font-display font-bold text-lg">{p.name}</p>
            <p className="text-sm text-zinc-400">{p.description || `Earn ${p.points_name || "points"} on purchases, visits and more — redeem for exclusive rewards.`}</p>
            {p.welcome_bonus > 0 && <p className="text-xs text-amber-300 mt-1 flex items-center gap-1"><Star size={12} /> {p.welcome_bonus} {p.points_name || "points"} welcome bonus</p>}
          </div>
          {joined[p.id] ? (
            <Link to="/my-rewards" className="shrink-0 bg-white/10 hover:bg-white/15 font-bold px-5 py-2.5 rounded-full text-sm" data-testid={`loyalty-view-${p.slug}`}>View my rewards</Link>
          ) : user ? (
            <button onClick={() => join(p)} className="shrink-0 bg-rose-500 hover:bg-rose-600 font-bold px-5 py-2.5 rounded-full text-sm" data-testid={`loyalty-join-${p.slug}`}>Join rewards</button>
          ) : (
            <Link to="/login" className="shrink-0 bg-rose-500 hover:bg-rose-600 font-bold px-5 py-2.5 rounded-full text-sm" data-testid={`loyalty-login-${p.slug}`}>Log in to join</Link>
          )}
        </div>
      ))}
    </div>
  );
}
